import { Component, Inject, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogActions,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AppService } from '@app/app.service';

export interface InfoDialogData {
  message: string;
  copyText?: string;
  message_warning?: boolean;
}

@Component({
  selector: 'app-info-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogContent,
  ],
  standalone: true,
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss',
})
export class InfoDialogComponent {
  appService = inject(AppService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InfoDialogData
  ) {}

  formatCopyText(value?: string): string {
    if (!value) {
      return '';
    }

    return value.match(/.{1,4}/g)?.join(' ') ?? value;
  }

  copyToClipboard(): void {
    if (!this.data.copyText) {
      return;
    }
    this.appService.showSnackBar('Copied to clipboard', 'success');
    navigator.clipboard.writeText(this.data.copyText);
  }
}